import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionListComponent } from './auction-list.component';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { AuctionPanelModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-panel';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { SortBarModule } from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  declarations: [AuctionListComponent],
  imports: [
    CommonModule,
    LoadingModule,
    AuctionPanelModule,
    SortBarModule,
    DirectivesModule,
    FGBSharedModule,
    InlineSVGModule.forRoot(),
  ],
  exports: [AuctionListComponent],
})
export class AuctionListModule {}
